import { useAuth } from "react-oidc-context";
import { useEffect } from "react";
import { createKeycloakLikeObject, KeycloakLikeObject } from "../utils/keycloakWrapper";

interface UseKeycloakReturn {
  keycloak: KeycloakLikeObject;
  initialized: boolean;
}

export const useKeycloak = (): UseKeycloakReturn => {
  const auth = useAuth();
  const keycloak = createKeycloakLikeObject(auth);

  // Auto-redirect to login if not authenticated and not loading
  useEffect(() => {
    if (!auth.isLoading && !auth.isAuthenticated && !auth.activeNavigator) {
      // Check if we're not already in the middle of a login flow
      const urlParams = new URLSearchParams(window.location.search);
      const hasAuthCode = urlParams.get('code');
      const hasAuthState = urlParams.get('state');

      // Only redirect if we're not handling a callback
      if (!hasAuthCode && !hasAuthState) {
        auth.signinRedirect();
      }
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.activeNavigator, auth]);

  return { keycloak, initialized: !auth.isLoading };
};